<animate-on-scroll [elements]="elementsToAnimate" [offset]="-50" [startDelay]="250" [staggerDelay]="200" [animateOnce]="true">
    <via-infographics>
        <div class="e-infographics-layout">

            <h1 class="e-page-title">Configure and Export VIA SKU Data</h1>
            <p class="e-page-subtitle">Your portal to personalised Via data exports.</p>

            <div class="e-infographic">
                <div class="e-infographic-item">
                    <div class="e-arrow" data-anim="slide-down" #animate></div>
                    <div class="e-infographic-content">
                        <div class="e-text" data-anim="slide-right" data-anim-delay="0.35s" #animate>
                            <h3>Filter through your subscription</h3>
                            <p>
                                Filter through your subscription and find the exact data you are looking for by selecting the
                                relevant countries and categories, and then refine that data even further by selecting applicable
                                suppliers, brands, attributes, and/or retailers.
                            </p>
                        </div>
                        <div class="e-image" data-anim="bounce" data-anim-delay="0.25s" #animate>
                            <img src="/assets/images/info-graphics/export/filters.svg" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                <div class="e-infographic-item">
                    <div class="e-arrow" data-anim="slide-down" #animate></div>
                    <div class="e-infographic-content">
                        <div class="e-text" data-anim="slide-left" data-anim-delay="0.35s" #animate>
                            <h3>Choose only the data that you want</h3>
                            <p>
                                Select only the data you need by configuring options like frequency, date range, data type, price
                                point, currency, and file type.
                            </p>
                        </div>
                        <div class="e-image" data-anim="bounce" data-anim-delay="0.25s" #animate>
                            <img src="/assets/images/info-graphics/export/data.svg" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                <div class="e-infographic-item">
                    <div class="e-arrow" data-anim="slide-down" #animate></div>
                    <div class="e-infographic-content">
                        <div class="e-text" data-anim="slide-right" data-anim-delay="0.35s" #animate>
                            <h3>Save and export your data</h3>
                            <p>
                                Once you are happy with your filter selections and configuration settings, you can save your
                                exported file by giving it a name and optional description.
                            </p>
                        </div>
                        <div class="e-image" data-anim="bounce" data-anim-delay="0.25s" #animate>
                            <img src="/assets/images/info-graphics/export/save-export.svg" aria-hidden="true" />
                        </div>
                    </div>
                </div>
                <div class="e-infographic-item">
                    <div class="e-arrow" data-anim="slide-down" #animate></div>
                    <div class="e-infographic-content">
                        <div class="e-text" data-anim="slide-left" data-anim-delay="0.35s" #animate>
                            <h3>Download or reload, the choice is yours</h3>
                            <p>
                                All exported files are available in the "My Downloads" section of your profile, where you can
                                download your data in the format you chose or reload the filter selections again for further
                                refinement.
                            </p>
                        </div>
                        <div class="e-image" data-anim="bounce" data-anim-delay="0.25s" #animate>
                            <img src="/assets/images/info-graphics/export/download.svg" aria-hidden="true" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </via-infographics>
</animate-on-scroll>
